import {Dto} from "./dto";

export abstract class BaseDto extends Dto {
    code: string;
    createdOn: number;
    deleted: boolean;

    abstract deserialize(input: any): this;
}
